let globalToastHandler = null;
let globalSubscriptionHandler = null;
let lastSubscriptionCheck = 0;

export const setGlobalToastHandler = (handler) => {
  globalToastHandler = handler;
};

export const setGlobalSubscriptionHandler = (handler) => {
  globalSubscriptionHandler = handler;
};

export const showGlobalToast = (message, type = "error", duration = 5000) => {
  if (globalToastHandler) {
    try {
      if (typeof globalToastHandler === "function") {
        const arity = globalToastHandler.length || 0;
        if (arity >= 3) return globalToastHandler(message, type, duration);
        if (arity === 2) return globalToastHandler(message, duration);
        return globalToastHandler(message);
      }
    } catch (e) {}
  } else {
    window.alert(message);
  }
};

export const markSubscriptionExpired = () => {
  const now = Date.now();
  if (now - lastSubscriptionCheck < 1000) {
    return false;
  }
  lastSubscriptionCheck = now;

  if (globalSubscriptionHandler) {
    return globalSubscriptionHandler();
  }
  return false;
};
